import { ExtraBase, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { onlyUnique } from './ArrayHelper';

export function SmartSendBulkExtrasApplier(
  smartSendItemsCache: SmartSendItemApiModel[],
  ids: string[],
  type: 'add' | 'remove',
  extras: ExtraBase[]
) {
  smartSendItemsCache
    .filter((x) => ids.includes(x.Id))
    .forEach((i) => {
      let unsaved = [];

      extras.forEach((e) => {
        if (type === 'add') {
          if (!i.Extras.find((x) => x.Id === e.Id)) {
            i.Extras.push({ Id: e.Id, Name: e.Name, Provider: e.Provider });
            unsaved.push('Extras');
          }
        }
        if (type === 'remove') {
          if (i.Extras.find((x) => x.Id === e.Id)) {
            i.Extras = i.Extras.filter((x) => x.Id !== e.Id);
            unsaved.push('Extras');
          }
        }
      });

      // Unique
      unsaved = unsaved.filter(onlyUnique);

      // Others Bulk Actions
      if (unsaved.length > 0) {
        i.State.unsaved = unsaved;
        i.State.state = 'SAVE';
      }
    });
}
